import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./index.scss";
import LeftBar from "./components/LeftBar";
import Main from "./components/Main";
import Login from "./components/Login";
import { checkAndRefreshToken, getToken } from "./helpers";
import { setOwner } from "./store/features/ownerSlice";
import axios from "axios";
import { useDispatch } from "react-redux";
import Orders from "./components/Orders";
import Products from "./components/Products";
import Clients from "./components/Clients";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ForgotPassword from "./components/ForgotPassword";

function App() {
  const API_URL = process.env.REACT_APP_API_URL;
  const WS_URL = process.env.REACT_APP_WS_URL;

  const dispatch = useDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!WS_URL) return;
    const socket = new WebSocket(WS_URL);

    socket.onopen = () => {
      console.log("🔌 Connected to WebSocket");
      socket.send("Привет, сервер!");
    };

    socket.onmessage = (event) => {
      console.log("📩 Новое сообщение:", event.data);
    };

    socket.onclose = () => {
      console.log("❌ WebSocket disconnected");
    };

    return () => socket.close();
  }, [WS_URL]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      checkAndRefreshToken();
    }, 1 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!API_URL) {
        console.error("API_URL is not defined");
        setLoading(false);
        return;
      }

      await checkAndRefreshToken();
      const token = await getToken();

      if (!token) {
        setIsAuthenticated(false);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/owners`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data) {
          dispatch(setOwner(response.data));
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.error("Ошибка при получении данных пользователя:", error);
        setIsAuthenticated(false);
      }
      setLoading(false);
    };

    fetchUserData();
  }, [API_URL, dispatch]);

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <Router>
      <ToastContainer position="top-right" autoClose={5000} />
      <Routes>
        {!isAuthenticated ? (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        ) : (
          <>
            <Route
              path="/*"
              element={
                <div className="app">
                  <LeftBar />
                  <div className="content">
                    <Routes>
                      <Route path="/" element={<Main />} />
                      <Route path="/orders" element={<Orders />} />
                      <Route path="/products" element={<Products />} />
                      {/* <Route path="/products/add" element={<AddProduct />} /> */}
                      <Route path="/clients" element={<Clients />} />
                      <Route path="*" element={<h2>Страница не найдена</h2>} />
                    </Routes>
                  </div>
                </div>
              }
            />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
